<script setup>
import { computed } from 'vue';
import { THEMES } from '@/constants';
import { usePage } from '@inertiajs/vue3';

const page = usePage();
const context = computed(() => page.props?.context);
const theme = context.value.theme;

const input = defineModel({type: String});

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    default: '',
  },
  autocomplete: {
    type: String,
    default: "on",
  },
  label: {
    type: String,
    required: true,
  },
  hideLabel: {
    type: Boolean,
    default: false,
  },
  validation: {
    type: Object,
    default: {},
  },
  type: {
    type: String,
    default: 'text',
  },
  inputClass: {
    type: [String, Array],
    default: '',
  },
});

const emit = defineEmits('keydown:enter');

const inputClasses = computed(() => [
  'py-2 px-3 w-full block border border-solid rounded-3xl',
  theme == THEMES.STUDY_AUS && 'border-primary-500 text-primary-900',
  theme == THEMES.STUDY_MELB && 'px-4',
]);
</script>

<template>
  <div>
    <label
      :for="name"
      :class="{'sr-only': hideLabel}"
      class="text-xs font-semibold"
    >{{ label }}</label>
    <input
      :id="name"
      v-model="input"
      :class="[inputClasses, ( validation.$error ? 'ring-1 ring-red' : 'bg-white'), inputClass]"
      :autocomplete="autocomplete"
      :type="type"
      :name="name"
      :placeholder="placeholder"
      @keydown.enter="emit('keydown:enter')"
    >
    <div
      v-if="validation.$error"
      class="text-red text-sm"
    >
      {{ validation.$errors[0].$message }}
    </div>
  </div>
</template>
